module.exports = __webpack_public_path__ + "static/avatar.00cc1fed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/jpg/avatar.jpg
// module id = 128
// module chunks = 114276838955818 198517197184460